import { FC } from 'react';

import { Breadcrumbs } from '@dbt-labs/sourdough';

import { MostQueriedModelsColumnChart } from '@/components/Charts/MostQueriedModelsChart';
import { Page } from '@/components/Page';
import { PageHeading } from '@/components/PageHeading';
import { useDbtCloudAccount } from '@/context/DbtCloudProvider';
import { useProjectBreadcrumbs } from '@/hooks/useBreadcrumbs';
import { MostExecutedModelsColumnChart } from '../../../../components/Charts/MostExecutedModelsColumnChart';
import { SlowestModelsColumnChart } from '../../../../components/Charts/SlowestModelsColumnChart';
import { MostFailedModelsCharts } from './components/MostFailedModelsCharts';

export interface PerformancePageProps {}

export const PerformancePage: FC<PerformancePageProps> = () => {
  const { projectName, accountId } = useDbtCloudAccount();

  const breadcrumbs = useProjectBreadcrumbs({
    additionalItems: [
      {
        text: 'Performance',
      },
    ],
  });

  if (!accountId) {
    return null;
  }

  return (
    <Page pageType="performance" title={`${projectName} - Performance`}>
      <Breadcrumbs className="mb-3" breadcrumbs={breadcrumbs} />
      <PerformancePageContent />
    </Page>
  );
};

interface PerformancePageContentProps {
  showHeader?: boolean;
}

export const PerformancePageContent: FC<PerformancePageContentProps> = ({
  showHeader = true,
}) => (
  <>
    {showHeader && <PageHeading className="mb-2">Performance</PageHeading>}
    <div className="mt-10 flex flex-col space-y-10">
      <MostExecutedModelsColumnChart />
      <SlowestModelsColumnChart />
      <MostFailedModelsCharts />
      <MostQueriedModelsColumnChart />
    </div>
  </>
);
